/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { useRequester } from '../../hooks';
import TutorResource, { TutorData } from '../../resources/TutorResource';
import TutorForm from './TutorForm';
import { Page } from '../../design';
import { AuthContext } from '../../contexts';

export default function TutorEditPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);

  const fetchTutor = useRequester<TutorResource>({
    onSubmit: (id) => TutorResource.fetchOne(id),
    onError: console.log,
  });

  const saveTutor = useRequester<TutorResource>({
    onSubmit: (data: any) =>
      id ? TutorResource.updateOne(id, data) : TutorResource.createOne(data),
    onSuccess: (ob) => navigate(`/tutors/${ob.data.id}`),
    onError: console.log,
  });

  useEffect(() => {
    id && fetchTutor.submit(id);
  }, [id]);

  let tutor;
  if (id) tutor = TutorResource.get(id).data as TutorData;

  if (id && !tutor) {
    return (
      <Page>
        <Page.Content>
          <Box className="flex flex-col items-center h-full justify-center">
            <CircularProgress />
          </Box>
        </Page.Content>
      </Page>
    );
  }

  return (
    <Page>
      <Page.Header>
        <Box className="flex flex-col h-full">
          <Typography variant="body1" color="text.secondary" sx={{ mt: 8 }}>
            👋 Hey, {user?.data.firstName}!
          </Typography>
          <Typography variant="h1">{id ? `Edit Tutor: ${tutor?.name}` : 'New Tutor'}</Typography>
          <Box className="flex-grow"></Box>
        </Box>
      </Page.Header>
      <Page.Content>
        <Box sx={{ mt: 5 }}>
          <TutorForm
            data={tutor}
            onSubmit={saveTutor.submit}
            saving={saveTutor.loading}
            error={saveTutor.error}
          />
        </Box>
      </Page.Content>
    </Page>
  );
}
